import React, {useEffect, useState} from "react";
import { Maybe } from "@src/types/global.types";
import Select from "react-select";
import {DictionaryFilterType, DictionaryType} from "@dictionary/types/dictionary.types";
import {getDictionaryCollection} from "@dictionary/utils/axios";
import {OnChangeValue} from "react-select/dist/declarations/src/types";

interface DictionarySelectProps {
    model: string,
    onChange: any,
    name?: Maybe<string>,
    value?: Maybe<DictionaryType>,
    required?: boolean,
    className?: Maybe<string>
    isClearable?: Maybe<boolean>
    placeholder?: Maybe<string>,
    isInvalid?: Maybe<boolean>,
    useDefault?: Maybe<boolean>,
}

const DictionarySelectComponent: React.FC<DictionarySelectProps> = (
    {model, onChange, value: initValue, name, className, isClearable, placeholder, isInvalid, useDefault}
) => {
    const [dictionaryCollection, setDictionaryCollection] = useState<DictionaryType[]>([]);
    const [isLoading, setLoading] = useState<boolean>(false);
    const [selectedValue, setSelectedValue] = useState<Maybe<DictionaryType>>();

    const fetchDictionaryCollection = () => {
        const filter: DictionaryFilterType = {model: model}
        setLoading(true);
        getDictionaryCollection(filter)
            .then((response: DictionaryType[]) => setDictionaryCollection(response))
            .finally(() => setLoading(false))
        ;
    }

    const loadSelectedValue = () => {
        if (!(initValue?.id ?? null)) {
            if (true === useDefault){
                changeSelectedOption(dictionaryCollection.find((dictionary: DictionaryType) => dictionary.default));
            } else {
                setSelectedValue(null);
            }
            return;
        }

        if (initValue && selectedValue && initValue.id === selectedValue.id) {
            const selectedOptionOK = Object.keys(selectedValue).length > 1;
            if (selectedOptionOK) {
                return;
            }
        }

        const initOptionOK =  Object.keys(initValue).length > 1;
        if (initOptionOK) {
            setSelectedValue(initValue);
            return;
        }

        setSelectedValue(dictionaryCollection.find((dictionary: DictionaryType) => dictionary.id === initValue.id));
    }

    const changeSelectedOption = (dictionary: DictionaryType) => {
        setSelectedValue(dictionary);
        onChange(dictionary, name);
    }

    const onChangeHandler = (dictionary: OnChangeValue<DictionaryType, false>) => {
        changeSelectedOption(dictionary);
    }

    useEffect(loadSelectedValue, [initValue, dictionaryCollection]);
    useEffect(fetchDictionaryCollection, [model]);

    if (isInvalid) {
        className = ` is-invalid ${className}`
    }

    return (
        <Select
            options={dictionaryCollection}
            name={name}
            value={selectedValue}
            className={'p-0 form-select ' + (className ? ` ${className}` : '')}
            getOptionLabel={(dictionary: DictionaryType) => dictionary.name}
            getOptionValue={(dictionary: DictionaryType) => dictionary.id}
            onChange={onChangeHandler}
            isLoading={isLoading}
            isClearable={isClearable}
            placeholder={placeholder ?? null}
            styles={{
                control: (baseStyles) => ({...baseStyles, width: 'auto', border: '0', minHeight: '0'}),
                dropdownIndicator: (baseStyles) => ({...baseStyles, padding: '6px 8px'}),
                clearIndicator: (baseStyles) => ({...baseStyles, padding: '6px 8px'}),
            }}
        />
    );
}

export default DictionarySelectComponent;
